import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ScreenTitle } from "src/shared/components/Typography";

interface Props {
  title: string;
  description?: ReactNode;
  onBack?: () => void;
  children: ReactNode;
}

/** Focused, editorial auth-step layout inspired by the attached mobile flow. */
export default function LoginStepLayout({
  title,
  description,
  onBack,
  children,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Stack spacing={{ xs: 3, sm: 3.5 }} width="100%">
      {onBack && (
        <IconButton
          aria-label={t("Back")}
          onClick={onBack}
          sx={{
            alignSelf: "flex-start",
            width: 48,
            height: 48,
            marginBottom: { xs: 0.5, sm: 1 },
            border: "1px solid",
            borderColor: "borderMuted",
            color: "text.primary",
            backgroundColor: "background.paper",
            "&:hover": { backgroundColor: "surfaceMuted" },
          }}
        >
          <ArrowBack />
        </IconButton>
      )}

      <Box>
        <ScreenTitle
          component="h1"
          sx={{
            maxWidth: 560,
            fontSize: { xs: 42, sm: 56 },
            lineHeight: { xs: 1.04, sm: 1 },
            letterSpacing: "-0.02em",
          }}
        >
          {title}
        </ScreenTitle>
        {description && (
          <Typography
            color="text.secondary"
            sx={{ marginTop: 1.5, fontSize: { xs: 16, sm: 18 } }}
          >
            {description}
          </Typography>
        )}
      </Box>

      {children}
    </Stack>
  );
}
